// extracted by mini-css-extract-plugin
export var measureBox = "_ag-0";